import { useEffect, useMemo } from 'react';

/**
 * Create a blob URL for a File and automatically revoke it on unmount / file change.
 * Returns `null` when no file is provided.
 */
export function useFilePreview(file: File | null | undefined): string | null {
  const blobUrl = useMemo(() => {
    if (!file) return null;
    return URL.createObjectURL(file);
  }, [file]);

  useEffect(() => {
    return () => {
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [blobUrl]);

  return blobUrl;
}
